const styles = theme => ({
    signOutBtn: {
      position: 'absolute',
      bottom: '0px',
      left: '0px',
      fontWeight: 'bold',
      width: '20vW',
      borderRadius: '0px',
      backgroundColor: '#90a4ae',
      height: '35px',
      boxShadow: '0px 0px 2px black',
      "&:hover":{
        color: 'white', 
        backgroundColor: '#304ffe'
      }
    }
  });
  
  export default styles;